import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import moment from 'moment-timezone';
import { Modal, Button } from 'react-bootstrap';
import { faEdit, faRefresh, faThumbsUp, faTrash, faSpinner, faPoll, faExclamationTriangle, faImage, faVideo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';
import noDataImage from "../assets/nodata.png"
import { json, Link, useNavigate } from 'react-router-dom';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ReactPaginate from 'react-paginate';
import { getEnabledPlatforms } from '../utils/platformUtils';
import { validateInstagramImageUrl } from '../utils/instagramValidation';
const ViewAllPendingPosts = () => {
  const navigate = useNavigate()
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [regenerating, setRegenerating] = useState({});
  const [postToDeactivate, setPostToDeactivate] = useState(null);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [approving, setApproving] = useState({});
  const [deactivating, setDeactivating] = useState({});
  const guid = localStorage.getItem("guid");
  const UserID = localStorage.getItem("UserID");

  const [currentPage, setCurrentPage] = useState(0);
  const postsPerPage = 6;

  const [showPollModal, setShowPollModal] = useState(false);
  const [questionData, setQuestionData] = useState({ question: "", options: ["", ""] });
  const [loadingPoll, setLoadingPoll] = useState(false);
  const [durationDays, setDurationDays] = useState(3); // Default 3 days
  const [post, setPost] = useState([]);
  const [expandedPosts, setExpandedPosts] = useState({});
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [activeMedia, setActiveMedia] = useState(null);
  const [enabledPlatforms, setEnabledPlatforms] = useState([]);
  const [platformsLoading, setPlatformsLoading] = useState(true);

  const styles = {
    pageCard: { border: 'none', backgroundColor: 'transparent' },
    headerBar: { borderRadius: '18px', padding: '18px 24px', backgroundColor: '#ffffff', border: '1px solid #eef0f8' },
    headerTitle: { fontSize: '22px', color: '#2e3192', fontWeight: 700, margin: 0 },
    refreshButton: { borderRadius: '999px', paddingInline: '18px', paddingBlock: '10px', fontWeight: 600 },
    gridRow: { marginTop: '4px', alignItems: 'stretch' },
    card: { borderRadius: '22px', border: '1px solid #eef0f8', padding: '24px', backgroundColor: '#ffffff', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'visible' },
    cardContent: { display: 'flex', flexDirection: 'column', gap: '20px', flexGrow: 1 },
    sectionTitle: { fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#858aad', fontWeight: 600, marginBottom: '8px' },
    scheduleHeading: { fontSize: '20px', color: '#2e3192', fontWeight: 700, marginBottom: '4px' },
    scheduleSubheading: { fontSize: '14px', color: '#6c7293', marginBottom: 0 },
    timezoneChip: { backgroundColor: '#eef0ff', color: '#2e3192', borderRadius: '999px', padding: '6px 12px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center' },
    expiredBadge: { backgroundColor: '#ffe9e9', color: '#d9534f', borderRadius: '999px', padding: '6px 14px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center', marginTop: '8px' },
    metaStack: { display: 'flex', flexDirection: 'column', gap: '8px' },
    mediaWrapper: {
      position: 'relative',
      borderRadius: '22px',
      background: 'linear-gradient(135deg, rgba(46,49,146,0.12) 0%, rgba(107,99,255,0.08) 100%)',
      padding: '18px',
      marginTop: '20px',
      overflow: 'hidden'
    },
    mediaHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
    mediaBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '12px',
      fontWeight: 700,
      color: '#2e3192',
      backgroundColor: '#ffffff',
      borderRadius: '999px',
      padding: '8px 14px',
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      boxShadow: '0 4px 12px rgba(46,49,146,0.15)'
    },
    mediaPreviewShell: {
      borderRadius: '18px',
      backgroundColor: '#fff',
      padding: '12px',
      boxShadow: '0 8px 24px rgba(46,49,146,0.12)'
    },
    mediaPreview: {
      borderRadius: '14px',
      overflow: 'hidden',
      backgroundColor: '#0f172a',
      height: '220px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    mediaFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '14px',
      color: '#4f5480',
      fontSize: '12px'
    },
    mediaFilename: { fontWeight: 600, wordBreak: 'break-all' },
    captionSection: { 
      marginTop: '16px', 
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0
    },
    captionSectionWithMedia: {
      marginTop: '16px', 
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      minHeight: 0
    },
    contentBox: { 
      backgroundColor: '#f8f9ff', 
      borderRadius: '18px', 
      padding: '18px', 
      color: '#34385b', 
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      overflow: 'visible',
      display: 'block'
    },
    contentBoxWithMedia: {
      backgroundColor: '#f8f9ff', 
      borderRadius: '18px', 
      padding: '18px', 
      color: '#34385b', 
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      overflow: 'visible',
      display: 'block',
      flexGrow: 1
    },
    contentBoxTruncated: {
      backgroundColor: '#f8f9ff', 
      borderRadius: '18px', 
      padding: '18px', 
      color: '#34385b', 
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      overflow: 'hidden',
      position: 'relative',
      maxHeight: '250px',
      minHeight: '120px',
      height: 'auto'
    },
    contentBoxTruncatedWithMedia: {
      backgroundColor: '#f8f9ff', 
      borderRadius: '18px', 
      padding: '18px', 
      color: '#34385b', 
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      overflow: 'hidden',
      position: 'relative',
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0,
      minHeight: '200px',
      maxHeight: '650px',
      height: 'auto',
      display: 'block'
    },
    promptBox: { backgroundColor: '#ffffff', border: '1px dashed #d9dcff', borderRadius: '18px', padding: '18px', color: '#4f5480' },
    actionIconButton: { borderRadius: '12px', border: '1px solid #eef0f8', backgroundColor: '#f7f8ff', padding: '10px 12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
    actionIcon: { fontSize: '20px' },
    actionsWrapper: { display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', gap: '16px', marginTop: '16px', width: '100%' },
    toggleLink: { marginTop: '8px', fontWeight: 600, color: '#2e3192', cursor: 'pointer', border: 'none', background: 'transparent', padding: 0 },
  };

  const ActionButton = ({ icon, label, onClick, disabled, tooltip, variant = 'outline-primary', loading = false }) => {
    const variantColor = (() => {
      switch (variant) {
        case 'success':
          return '#28a745';
        case 'outline-danger':
          return '#ff4d4d';
        case 'outline-dark':
          return '#343a40';
        default:
          return '#2e3192';
      }
    })();

    const button = (
      <button
        type="button"
        className="btn btn-icon-only"
        style={{ ...styles.actionIconButton, opacity: disabled || loading ? 0.6 : 1 }}
        onClick={onClick}
        disabled={disabled || loading}
      >
        <FontAwesomeIcon
          icon={loading ? faSpinner : icon}
          spin={loading}
          style={{ ...styles.actionIcon, color: variantColor }}
        />
        <span className="visually-hidden">{label}</span>
      </button>
    );

    if (!tooltip) {
      return button;
    }

    return (
      <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-${label.replace(/\s+/g, '-').toLowerCase()}`}>{tooltip}</Tooltip>}>
        <span className="d-inline-flex">{button}</span>
      </OverlayTrigger>
    );
  };


  // Triggered when user clicks the edit icon
  const handleCreatePoll = async (post) => {
    setLoadingPoll((prev) => ({ ...prev, [post.ContentId]: true }));
    try {
      setPost(post)
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/generate-poll`, {
        prompt: post.Content,  // Assuming post.content contains the relevant prompt
      });

      if (res.data?.newContent?.question && res.data?.newContent?.options) {
        setQuestionData({
          question: res.data.newContent?.question,
          options: res.data.newContent.options?.slice(0, 4),
        });
        setShowPollModal(true);
      } else {
        Swal.fire("Error", "Poll generation failed", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setLoadingPoll((prev) => ({ ...prev, [post.ContentId]: false }));
    }
  };

  const handlePollSubmit = async () => {
    try {
      const validOptions = questionData.options.filter((opt) => opt.trim() !== "");

      if (!questionData.question.trim() || validOptions.length < 2) {
        Swal.fire("Error", "Please enter a question and at least two options.", "warning");
        return;
      }

        const tooLongOptions = validOptions.filter(opt => opt.length > 30);
    if (tooLongOptions.length > 0) {
      Swal.fire("Error", "Each option must be 30 characters or less.", "warning");
      return;
    }
    
      const postid = post?.PostId;         // assuming `post` is set from handleCreatePoll
      const contentid = post?.ContentId;   // same as above

      const questionwithoptions = {
        question: questionData.question,
        options: validOptions,
      };

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/updatePollQuestionwithOptions`, {
        postid,
        contentid,
        questionwithoptions: JSON.stringify(questionwithoptions),
        pollrequired: true,                // Always passing `true` as per your requirement
        PollDuration: durationDays,        // assuming you are managing `durationDays` from dropdown
      });

      if (response.data.message === "updated successfully") {
        Swal.fire("Success", "Poll created successfully", "success");
        setShowPollModal(false);
      } else {
        Swal.fire("Error", "Failed to post poll", "error");
      }

    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Poll creation failed", "error");
    }
  };


  const handleUpdateClick = (post) => {
    navigate(`/updatependingpost/${post.ContentId}`)
  };

  const handleUpdateClickwithDropdown = (post) => {
    navigate(`/updatependingpostdropdown/${post.ContentId}`)
  };

  const isPostExpired = (post) => {
    if (!post?.ScheduledPostDate || !post?.ScheduledTimeAsPerZone) return false;

    // Extract just the time part, ignoring the timezone (Z)
    const timePart = post.ScheduledTimeAsPerZone.split("T")[1].replace('Z', '');

    // Combine with date (ignore the time in ScheduledPostDate)
    const combinedDateTimeStr = `${post.ScheduledPostDate.split("T")[0]}T${timePart}`;

    // Force parse in Asia/Kolkata
    const scheduledDateTime = moment.tz(combinedDateTimeStr, 'YYYY-MM-DDTHH:mm:ss', post.TimeZone);

    const now = moment().tz(post.TimeZone);

    return scheduledDateTime.isBefore(now);
  };

  const getScheduledDateTime = (post) => {
    if (!post?.ScheduledPostDate || !post?.ScheduledTimeAsPerZone) {
      // If no scheduled date, put at the end
      return moment().add(100, 'years');
    }

    // Extract just the time part, ignoring the timezone (Z)
    const timePart = post.ScheduledTimeAsPerZone.split("T")[1].replace('Z', '');

    // Combine with date (ignore the time in ScheduledPostDate)
    const combinedDateTimeStr = `${post.ScheduledPostDate.split("T")[0]}T${timePart}`;

    // Parse in the post's timezone
    return moment.tz(combinedDateTimeStr, 'YYYY-MM-DDTHH:mm:ss', post.TimeZone || 'Asia/Kolkata');
  };

  const fetchPosts = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallaigeneratedpostsbyUserID/${UserID}`);
      if (response.data.length !== 0) {
        const pendingPosts = response.data.filter((x) => x.Status === 'PENDING');
        
        // Separate expired and non-expired posts
        const nonExpiredPosts = pendingPosts.filter(post => !isPostExpired(post));
        const expiredPosts = pendingPosts.filter(post => isPostExpired(post));
        
        // Sort non-expired posts in ascending order by scheduled date/time
        nonExpiredPosts.sort((a, b) => {
          const dateA = getScheduledDateTime(a);
          const dateB = getScheduledDateTime(b);
          return dateA.valueOf() - dateB.valueOf();
        });
        
        // Sort expired posts in descending order (most recently expired first)
        expiredPosts.sort((a, b) => {
          const dateA = getScheduledDateTime(a);
          const dateB = getScheduledDateTime(b);
          return dateB.valueOf() - dateA.valueOf();
        });
        
        // Combine: non-expired first, then expired
        setPosts([...nonExpiredPosts, ...expiredPosts]);
        console.log(response.data);
      }
      setLoading(false);
    } catch (err) {
      console.error('Failed to fetch posts:', err.message);
      setError('Failed to fetch posts');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, [UserID]);

  // Fetch enabled platforms for knack_feeds module
  useEffect(() => {
    const fetchPlatforms = async () => {
      setPlatformsLoading(true);
      const platforms = await getEnabledPlatforms('knackFeeds');
      setEnabledPlatforms(platforms);
      setPlatformsLoading(false);
    };
    fetchPlatforms();
  }, []);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const offset = currentPage * postsPerPage;
  const currentPosts = posts.slice(offset, offset + postsPerPage);

  const resolveMediaDetails = (mediaPath = '') => {
    if (!mediaPath) return null;
    const normalized = `${mediaPath}`.trim().replace(/\\/g, '/');
    if (!normalized) return null;

    const isFullUrl = /^https?:\/\//i.test(normalized);
    const isAzureBlobUrl = normalized.includes('blob.core.windows.net');
    const isLinkedInAsset = normalized.includes('linkedin.com') || normalized.includes('media.licdn.com');

    const pathWithoutQuery = normalized.split('?')[0];
    const extension = pathWithoutQuery.split('.').pop()?.toLowerCase() || '';
    const filename = pathWithoutQuery.split(/[/\\]/).pop() || '';

    let mediaType = 'unknown';
    if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
      mediaType = 'video';
    } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension) || isLinkedInAsset) {
      mediaType = 'image';
    }

    const source = encodeURI(
      isFullUrl || isAzureBlobUrl || isLinkedInAsset
        ? normalized
        : `${process.env.REACT_APP_API_BASE_URL}/${normalized}`
    );

    return {
      source,
      mediaType,
      filename,
    };
  };

  const renderMediaPreview = (mediaDetails) => {
    if (!mediaDetails) {
      return (
        <div className="text-muted">
          Media not available.
        </div>
      );
    }

    if (mediaDetails.mediaType === 'video') {
      return (
        <video
          controls
          style={{ width: '100%', height: '100%', maxHeight: '320px', borderRadius: '14px' }}
        >
          <source src={mediaDetails.source} />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (mediaDetails.mediaType === 'image') {
      return (
        <img
          src={mediaDetails.source}
          alt="Post media"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      );
    }

    return (
      <div className="text-muted">
        Preview not available for this file type.
      </div>
    );
  };

  const getMediaIcon = (mediaType) => (mediaType === 'video' ? faVideo : faImage);

  const getMediaLabel = (mediaType) => {
    if (mediaType === 'video') return 'Video Attachment';
    if (mediaType === 'image') return 'Image Attachment';
    return 'Media Attachment';
  };

  const getMediaInteractionHint = (mediaType) => {
    if (mediaType === 'video') return 'Tap to play';
    if (mediaType === 'image') return 'Tap to zoom';
    return 'View media';
  };

  const getMediaFilename = (mediaDetails) => {
    if (!mediaDetails) return '';
    return mediaDetails.filename;
  };

  const handleMediaPreviewClick = (mediaDetails) => {
    if (!mediaDetails || mediaDetails.mediaType === 'unknown') return;
    setActiveMedia(mediaDetails);
    setShowMediaModal(true);
  };

  const handleCloseMediaModal = () => {
    setShowMediaModal(false);
    setActiveMedia(null);
  };

  const renderModalMedia = () => {
    if (!activeMedia) return null;

    if (activeMedia.mediaType === 'video') {
      return (
        <video controls style={{ width: '100%', borderRadius: '12px' }}>
          <source src={activeMedia.source} />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (activeMedia.mediaType === 'image') {
      return (
        <img
          src={activeMedia.source}
          alt={activeMedia.filename || 'Preview'}
          style={{ width: '100%', borderRadius: '12px', objectFit: 'contain' }}
        />
      );
    }

    return null;
  };

  const toggleContent = (contentId) => {
    setExpandedPosts(prev => ({ ...prev, [contentId]: !prev[contentId] }));
  };

  const handleRegenerate = async (ContentId, Prompts) => {

    setRegenerating((prev) => ({ ...prev, [ContentId]: true }));
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/regenerate`,
        { ContentId, UserID, Prompts },
        { headers: { 'Content-Type': 'application/json' } }
      );

      const newContent = response.data.newContent;

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Post regenerated successfully',
        showConfirmButton: false,
        timer: 3000
      });

      // Update local state
      setPosts(posts.map(post =>
        post.ContentId === ContentId ? { ...post, Content: newContent } : post
      ));
    } catch (err) {
      console.error('Failed to regenerate post:', err.message);
      setError('Failed to regenerate post');
    } finally {
      setRegenerating((prev) => ({ ...prev, [ContentId]: false }));
    }
  };

  const handleApprove = async (ContentId) => {
    setApproving((prev) => ({ ...prev, [ContentId]: true }));
    
    // Find the post to get its data
    const post = posts.find(p => p.ContentId === ContentId);
    if (!post) {
      setApproving((prev) => ({ ...prev, [ContentId]: false }));
      Swal.fire({
        icon: 'error',
        title: 'Post not found',
        text: 'Unable to find the post. Please refresh the page.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#2e3192'
      });
      return;
    }

    // Check if Instagram is enabled
    const isInstagramEnabled = enabledPlatforms.some(p => p.code === 'instagram' || p.name?.toLowerCase() === 'instagram');
    
    // Check if it's a poll (polls don't need image validation)
    const isPoll = post.QuestionwithOptions && 
                   post.QuestionwithOptions !== 'null' && 
                   post.QuestionwithOptions !== '' &&
                   post.QuestionwithOptions.trim() !== '';
    
    // Get image URL
    const imageUrl = post.Image || null;
    const hasImage = !!imageUrl;
    
    // Validate Instagram image BEFORE approving if Instagram is enabled and not a poll
    if (isInstagramEnabled && !isPoll) {
      // Check if image is required
      if (!hasImage) {
        setApproving((prev) => ({ ...prev, [ContentId]: false }));
        await Swal.fire({
          icon: 'error',
          title: 'Image Required for Instagram',
          html: `
            <div style="text-align: left;">
              <p style="margin-bottom: 15px;"><strong>Instagram requires an image to post.</strong></p>
              <p style="margin-bottom: 20px; color: #666;">Please add an image to your post before approving for Instagram.</p>
            </div>
          `,
          confirmButtonText: 'OK',
          confirmButtonColor: '#2e3192',
        });
        return;
      }
      
      // Validate image aspect ratio
      try {
        const validationResult = await validateInstagramImageUrl(imageUrl);
        
        if (validationResult && !validationResult.isValid) {
          setApproving((prev) => ({ ...prev, [ContentId]: false }));
          await Swal.fire({
            icon: 'error',
            title: 'Invalid Image Aspect Ratio for Instagram',
            html: `
              <div style="text-align: left;">
                <p style="margin-bottom: 15px;"><strong>${validationResult.error || 'Image does not meet Instagram requirements.'}</strong></p>
                <p style="margin-bottom: 20px; color: #666;">Instagram requires images with aspect ratios between 0.8:1 and 1.91:1 (approximately 4:5 portrait to 1.91:1 landscape).</p>
                <p style="color: #666;">Please select a different image with a valid aspect ratio before approving.</p>
              </div>
            `,
            confirmButtonText: 'OK',
            confirmButtonColor: '#2e3192',
          });
          return;
        }
      } catch (validationError) {
        console.error('Error validating Instagram image:', validationError);
        // If validation fails due to technical issues, warn but allow to proceed
        // (backend will catch it anyway)
        const result = await Swal.fire({
          icon: 'warning',
          title: 'Image Validation Warning',
          text: 'Unable to validate image aspect ratio. The post will be approved, but Instagram may reject it if the aspect ratio is invalid.',
          confirmButtonText: 'Continue',
          confirmButtonColor: '#2e3192',
          showCancelButton: true,
          cancelButtonText: 'Cancel',
          cancelButtonColor: '#6c757d',
        });
        
        if (!result.isConfirmed) {
          setApproving((prev) => ({ ...prev, [ContentId]: false }));
          return;
        }
      }
    }
    
    try {
      const resp = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/approve-post`,
        { ContentId, Status: "APPROVED" },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (resp.data.message === 'Post approved successfully') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Post approved successfully',
          showConfirmButton: false,
          timer: 3000
        });

        setPosts(posts.filter(post => post.ContentId !== ContentId));
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error approving post!',
          showConfirmButton: false,
          timer: 3000
        });
      }
    } catch (err) {
      console.error('Failed to approve post:', err.message);
      
      // Check for validation errors (image/caption issues)
      const errorData = err.response?.data;
      if (errorData?.error && (errorData?.errorType === 'image_validation' || errorData?.errorType === 'caption_too_long' || errorData?.errorType === 'image_required')) {
        const platformName = errorData.platform === 'instagram' ? 'Instagram' : errorData.platform === 'facebook' ? 'Facebook' : errorData.platform;
        const errorDetails = errorData.errorDetails || {};
        
        // Handle caption too long error
        if (errorData?.errorType === 'caption_too_long') {
          const captionLength = errorDetails.captionLength || 'N/A';
          const maxLength = errorDetails.maxLength || 2200;
          const charactersOver = errorDetails.charactersOver || 'N/A';
          
          Swal.fire({
            icon: 'error',
            title: `${platformName} Caption Too Long`,
            html: `
              <div style="text-align: left;">
                <p style="margin-bottom: 10px;"><strong>${errorData.message}</strong></p>
                ${captionLength !== 'N/A' ? `<p style="margin-bottom: 5px;">Current length: ${captionLength} characters</p>` : ''}
                ${maxLength ? `<p style="margin-bottom: 5px;">Maximum allowed: ${maxLength} characters</p>` : ''}
                ${charactersOver !== 'N/A' ? `<p style="margin-bottom: 5px; color: #e74c3c; font-weight: bold;">Characters over limit: ${charactersOver}</p>` : ''}
                <p style="margin-top: 10px; color: #666;">Please shorten your caption to ${maxLength} characters or less before approving.</p>
              </div>
            `,
            showConfirmButton: true,
            confirmButtonText: 'OK',
            confirmButtonColor: '#2e3192',
            width: '500px'
          });
          setApproving((prev) => ({ ...prev, [ContentId]: false }));
          return;
        }
        
        // Handle image validation error
        if (errorData?.errorType === 'image_validation') {
          const aspectRatio = errorDetails.aspectRatio || 'N/A';
          const dimensions = errorDetails.dimensions || 'N/A';
          
          Swal.fire({
            icon: 'error',
            title: `${platformName} Image Error`,
            html: `
              <div style="text-align: left;">
                <p style="margin-bottom: 10px;"><strong>${errorData.message}</strong></p>
                ${dimensions !== 'N/A' ? `<p style="margin-bottom: 5px;">Image dimensions: ${dimensions}</p>` : ''}
                ${aspectRatio !== 'N/A' ? `<p style="margin-bottom: 5px;">Aspect ratio: ${aspectRatio}:1</p>` : ''}
                <p style="margin-top: 10px; color: #666;">Please upload a different image with a valid aspect ratio (between 0.8:1 and 1.91:1) before approving.</p>
              </div>
            `,
            showConfirmButton: true,
            confirmButtonText: 'OK',
            confirmButtonColor: '#2e3192',
            width: '500px'
          });
          setApproving((prev) => ({ ...prev, [ContentId]: false }));
          return;
        }
        
        // Handle image required error
        if (errorData?.errorType === 'image_required') {
          Swal.fire({
            icon: 'error',
            title: `${platformName} Image Required`,
            text: errorData.message || 'Image is required for this platform. Please add an image before approving.',
            showConfirmButton: true,
            confirmButtonText: 'OK',
            confirmButtonColor: '#2e3192'
          });
          setApproving((prev) => ({ ...prev, [ContentId]: false }));
          return;
        }
      }
      
      setError('Failed to approve post');
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error approving post!',
        text: err.response?.data?.message || err.message || 'An error occurred while approving the post.',
        showConfirmButton: false,
        timer: 3000
      });
    } finally {
      setApproving((prev) => ({ ...prev, [ContentId]: false }));
    }
  };

  const handleDeactivateClick = (post) => {
    setPostToDeactivate(post);
    setShowDeactivateModal(true);
  };
  // const renderMedia = (imagePath) => {
  //     if (imagePath) {
  //       // Convert backslashes to forward slashes for URLs
  //       const normalizedPath = imagePath.replace(/\\/g, '/');
  //       const fileExtension = normalizedPath.split('.').pop().toLowerCase();
  //       const fileUrl = `${process.env.REACT_APP_API_BASE_URL}/${normalizedPath}`;

  //       if (['mp4', 'mov', 'avi'].includes(fileExtension)) {
  //         return (
  //           <div className='mt-3  text-center'>
  //             <video width="320" height="120" controls>
  //               <source src={fileUrl} type={`video/${fileExtension}`} />
  //               Your browser does not support the video tag.
  //             </video>
  //           </div>
  //         );
  //       } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
  //         return (
  //           <div className='mt-3  text-center'>
  //             <img src={fileUrl} alt="Post Media" height={100} width={100} />
  //           </div>
  //         );
  //       }
  //     }
  //     return null;
  //   };


  const handleConfirmDeactivate = async () => {
    if (!postToDeactivate) return;

    setDeactivating((prev) => ({ ...prev, [postToDeactivate.ContentId]: true }));

    try {
      const resp = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/deactivate-post`,
        { ContentId: postToDeactivate.ContentId, Status: "REJECTED" },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (resp.data.message === 'Post deactivated successfully') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Post deleted successfully',
          showConfirmButton: false,
          timer: 3000
        });

        setPosts(posts.filter(post => post.ContentId !== postToDeactivate.ContentId));
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error deactivating post!',
          showConfirmButton: false,
          timer: 3000
        });
      }
    } catch (err) {
      console.error('Failed to deactivate post:', err.message);
      setError('Failed to deactivate post');
    } finally {
      setDeactivating((prev) => ({ ...prev, [postToDeactivate.ContentId]: false }));
      setShowDeactivateModal(false);
      setPostToDeactivate(null);
    }
  };

  const handleCloseDeactivateModal = () => {
    setShowDeactivateModal(false);
    setPostToDeactivate(null);
  };
  const handleDate = (scheduledPostDate) => {
    // Combine date and time into a single datetime string
    const dateTimeString = `${scheduledPostDate?.split('T')[0]}`;

    // Parse the combined date-time string
    const dateTime = moment.utc(dateTimeString);

    // Format date and local time
    const date = dateTime.format('MM-DD-YYYY');
    const time = dateTime.local().format('HH:mm');

    return { date };
  };

  // const handleTime = (scheduledTimeAsPerZone) => {
  //   if (!scheduledTimeAsPerZone) {
  //     return { time: 'No time available' }; // Handle empty or undefined input
  //   }

  //   // Split the string by 'T' and take the second part (time)
  //   const timeString = scheduledTimeAsPerZone?.split('T')[1];

  //   // If there's a time part, format it; otherwise, return an error message
  //   if (timeString) {
  //     const timeParts = timeString.split(':');
  //     const formattedTime = `${timeParts[0]}:${timeParts[1]}`; // Get hours and minutes
  //     return { time: formattedTime };
  //   } else {
  //     return { time: 'Invalid time' };
  //   }
  // };
  const handleTime = (value) => (value ? (moment.parseZone(value, moment.ISO_8601, true).isValid() ? moment.parseZone(value, moment.ISO_8601, true).format('hh:mm A') : moment(value, 'HH:mm', true).isValid() ? moment(value, 'HH:mm', true).format('hh:mm A') : value) : '');

  return (

    <SideNavbar>

      <div className="card shadow-sm mt-3" style={styles.pageCard}>
        <div style={styles.headerBar} className="d-flex flex-wrap justify-content-between align-items-center gap-3">
          <Link
            to={
              localStorage.getItem('RoleID') == '4'
                ? '/Pagehome'
                : localStorage.getItem('RoleID') == '1'
                  ? '/home'
                  : '/adminhome'
            }
            className="text-decoration-none d-flex align-items-center gap-3"
          >
            <span className="d-inline-flex align-items-center justify-content-center rounded-circle" style={{ width: 40, height: 40, backgroundColor: '#eef0ff' }}>
              <i className="fa fa-arrow-left" aria-hidden="true" style={{ color: '#2e3192' }}></i>
            </span>
            <h5 className="welcome-text" style={styles.headerTitle}>
              Pending Posts
            </h5>
          </Link>

          <button className="btn btn-outline-primary d-flex align-items-center gap-2" style={styles.refreshButton} onClick={fetchPosts}>
            <FontAwesomeIcon icon={faRefresh} />
            <span>Refresh</span>
          </button>
        </div>

        <div className="container-fluid" style={{ padding: '4px 16px' }}>
          {error && (
            <div className="alert alert-danger d-flex align-items-center gap-2 mb-4" role="alert">
              <FontAwesomeIcon icon={faExclamationTriangle} />
              <span>{error}</span>
            </div>
          )}
          
          {/* Disclaimer for image selection */}
          {!loading && posts.length > 0 && (
            <div style={{
              marginTop: '16px',
              //marginBottom: '4px',
              padding: '12px 16px',
              backgroundColor: '#e3f2fd',
              border: '1px solid #90caf9',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <FontAwesomeIcon 
                icon={faImage} 
                style={{ 
                  color: '#1976d2', 
                  fontSize: '18px',
                  flexShrink: 0
                }} 
              />
              <div style={{ flex: 1 }}>
                <p style={{ 
                  margin: 0, 
                  fontSize: '14px', 
                  color: '#1565c0',
                  fontWeight: '500'
                }}>
                  💡 Want to add an image to your posts?
                </p>
                <p style={{ 
                  margin: '4px 0 0 0', 
                  fontSize: '13px', 
                  color: '#424242'
                }}>
                  Click the <strong style={{ color: '#1976d2' }}>Edit</strong> button on any post to select an image from AI suggestions or upload your own.
                </p>
              </div>
            </div>
          )}

          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <div className="spinner"></div>
            </div>
          ) : posts.length === 0 ? (
            <div className="text-center py-5">
              <img src={noDataImage} alt="No Data" style={{ width: '280px', maxWidth: '60%' }} />
              <p style={{ color: '#2e3192', fontSize: '18px', fontWeight: 600, marginTop: '18px' }}>No pending posts right now!</p>
              <p className="text-muted mb-0">Try refreshing or generating new content to see it here.</p>
            </div>
          ) : (
            <div className="row g-4" style={styles.gridRow}>
              {currentPosts.map((post, index) => {
                const { date } = handleDate(post?.ScheduledPostDate);
                const time = handleTime(post?.ScheduledTimeAsPerZone);
                const expired = isPostExpired(post);
                const canGeneratePoll = !post?.image && !post?.Image;
                const mediaPath = post.image || post.Image;
                const mediaDetails = resolveMediaDetails(mediaPath);
                
                // Calculate row index (2 cards per row with col-md-6)
                const rowIndex = Math.floor(index / 2);
                
                // Check if any card in the same row has media
                const rowStartIndex = rowIndex * 2;
                const rowEndIndex = Math.min(rowStartIndex + 2, currentPosts.length);
                const hasMediaInRow = currentPosts.slice(rowStartIndex, rowEndIndex).some(p => {
                  const pMediaPath = p.image || p.Image;
                  return pMediaPath;
                });
                return (
                  <div className="col-12 col-md-6" key={post.ContentId}>
                    <div className="shadow-sm" style={styles.card}>
                      <div style={styles.cardContent}>
                        <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
                          <div style={styles.metaStack}>
                            <span style={styles.sectionTitle}>Scheduled for</span>
                            <div>
                              <div style={styles.scheduleHeading}>{date || 'Not scheduled'}</div>
                              <p style={styles.scheduleSubheading}>{time || 'Time not selected'}</p>
                            </div>
                          </div>
                          <div className="text-end d-flex flex-column align-items-end gap-2">
                            <span style={styles.timezoneChip}>{post?.TimeZone || 'Timezone pending'}</span>
                            {expired && <span style={styles.expiredBadge}>Expired</span>}
                          </div>
                        </div>

                        <div>
                          <div style={styles.sectionTitle}>Prompt</div>
                          <div style={styles.promptBox}>{post?.Prompts || 'No prompt provided.'}</div>
                        </div>

                        {mediaDetails && (
                          <div style={styles.mediaWrapper}>
                            <div style={styles.mediaHeader}>
                              <span style={styles.mediaBadge}>
                                <FontAwesomeIcon
                                  icon={getMediaIcon(mediaDetails.mediaType)}
                                  style={{ fontSize: '16px' }}
                                />
                                {getMediaLabel(mediaDetails.mediaType)}
                              </span>
                            </div>
                            <div style={styles.mediaPreviewShell}>
                              <div
                                style={{
                                  ...styles.mediaPreview,
                                  cursor: mediaDetails.mediaType !== 'unknown' ? 'zoom-in' : 'default'
                                }}
                                role={mediaDetails.mediaType !== 'unknown' ? 'button' : undefined}
                                tabIndex={mediaDetails.mediaType !== 'unknown' ? 0 : undefined}
                                onClick={() => handleMediaPreviewClick(mediaDetails)}
                                onKeyDown={(event) => {
                                  if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault();
                                    handleMediaPreviewClick(mediaDetails);
                                  }
                                }}
                              >
                                {renderMediaPreview(mediaDetails)}
                              </div>
                            </div>
                            <div style={styles.mediaFooter}>
                              <span style={styles.mediaFilename}>{getMediaFilename(mediaDetails)}</span>
                              <span>{getMediaInteractionHint(mediaDetails.mediaType)}</span>
                            </div>
                          </div>
                        )}

                        <div style={hasMediaInRow ? styles.captionSectionWithMedia : styles.captionSection}>
                          <div style={styles.sectionTitle}>Post Caption</div>
                          <div style={
                            expandedPosts[post.ContentId] 
                              ? (hasMediaInRow ? styles.contentBoxWithMedia : styles.contentBox)
                              : (hasMediaInRow ? styles.contentBoxTruncatedWithMedia : styles.contentBoxTruncated)
                          }>
                            {post?.Content || 'No content available.'}
                          </div>
                          {post?.Content && (
                            <button style={styles.toggleLink} onClick={() => toggleContent(post.ContentId)}>
                              {expandedPosts[post.ContentId] ? 'Show Less' : 'Read More'}
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="mt-4" style={styles.actionsWrapper}>
                        <ActionButton
                          icon={faRefresh}
                          label="Regenerate"
                          tooltip="Regenerate the content with the same prompt"
                          onClick={() => handleRegenerate(post.ContentId, post.Prompts)}
                          loading={!!regenerating[post.ContentId]}
                        />

                        <ActionButton
                          icon={faEdit}
                          label="Edit"
                          tooltip="Edit content details"
                          onClick={() => handleUpdateClick(post)}
                        />

                        {canGeneratePoll && (
                          <ActionButton
                            icon={faPoll}
                            label="Create Poll"
                            tooltip="Generate a poll for this post"
                            onClick={() => handleCreatePoll(post)}
                            loading={!!loadingPoll[post.ContentId]}
                          />
                        )}

                        <ActionButton
                          icon={faThumbsUp}
                          label="Approve"
                          variant="success"
                          tooltip="Approve and schedule this post"
                          onClick={() => handleApprove(post.ContentId)}
                          loading={!!approving[post.ContentId]}
                        />

                        <ActionButton
                          icon={faTrash}
                          label="Reject"
                          variant="outline-danger"
                          tooltip="Reject this post"
                          onClick={() => handleDeactivateClick(post)}
                          loading={!!deactivating[post.ContentId]}
                        />

                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <ReactPaginate
          previousLabel={"Previous"}
          nextLabel={"Next"}
          pageCount={Math.ceil(posts.length / postsPerPage)}
          onPageChange={handlePageChange}
          containerClassName={"pagination"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          activeClassName={"active"}
          disabledClassName={"disabled"}
          breakLabel={"..."}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
        />

        <Modal show={showDeactivateModal} onHide={handleCloseDeactivateModal}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Post</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this post?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDeactivateModal}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirmDeactivate}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showMediaModal} onHide={handleCloseMediaModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Media Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {renderModalMedia()}
            {activeMedia?.filename && (
              <p className="mt-3 text-muted text-center" style={{ fontWeight: 600 }}>
                {activeMedia.filename}
              </p>
            )}
          </Modal.Body>
        </Modal>

        <Modal show={showPollModal} onHide={() => setShowPollModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Create Poll</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="question-editor">
              <label>Poll Question:</label>
              <input
                type="text"
                value={questionData.question}
                onChange={(e) =>
                  setQuestionData({ ...questionData, question: e.target.value })
                }
                className="form-control mb-2"
                placeholder="Enter your question"
              />

              <label>Options:</label>
              {questionData.options.map((opt, idx) => (
                <div key={idx} className="d-flex align-items-center mb-2">
                  <input
                    type="text"
                    value={opt}
                    onChange={(e) => {
                      const newOptions = [...questionData.options];
                      newOptions[idx] = e.target.value;
                      setQuestionData({ ...questionData, options: newOptions });
                    }}
                    className="form-control me-2"
                  />
                  {questionData.options.length > 2 && (
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        const newOptions = questionData.options.filter((_, i) => i !== idx);
                        setQuestionData({ ...questionData, options: newOptions });
                      }}
                    >
                      <i className="fa fa-trash text-white"></i>
                    </button>
                  )}
                </div>
              ))}

              {questionData.options.length < 4 && (
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    setQuestionData({ ...questionData, options: [...questionData.options, ""] })
                  }
                >
                  <i className="fa fa-plus text-white"></i>
                </button>
              )}
              <div className="form-group mt-3">
                <label htmlFor="duration">Poll Duration</label>
                <select
                  id="duration"
                  className="form-control"
                  value={durationDays}
                  onChange={(e) => setDurationDays(parseInt(e.target.value))}
                >
                  <option value={1}>1 Day</option>
                  <option value={3}>3 Days</option>
                  <option value={7}>7 Days</option>
                </select>
              </div>

            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-secondary" onClick={() => setShowPollModal(false)}>
              Cancel
            </button>
            <button className="btn btn-success" onClick={handlePollSubmit}>
              Create Poll
            </button>
          </Modal.Footer>
        </Modal>

      </div>
    </SideNavbar>
  );
};

export default ViewAllPendingPosts;
